import {usePeople, useUploadMedia, useImgDescs, useAddImgDesc, usePrompt, useUpdatePerson} from "../hooks/hooks_index";
import {useState, useRef, useEffect} from "react";
import {useAuthUser, getLocalDateStringISO} from "../components/components_index";
import '../styles/EditImg.css';
import { Link } from "react-router-dom";

export default function EditImg() {
  const fileInputRef = useRef(null);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [submitted, setSubmitted] = useState(false);
  const [inputDetails, setInputDetails] = useState(false);
  const [inputtingID, setInputtingID] = useState(null);
  const [currIdx, setCurrIdx] = useState(null);
  const [selectedDescs, setSelectedDescs] = useState([]);
  const [isData, setIsData] = useState(false);
  const [peopleNames, setPeopleNames] = useState([]);
  const [dayArray, setDayArray] = useState([]);
  const [isLeapYear, setIsLeapYear] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [numDone, setNumDone] = useState(0);

  const {data: people, isLoading, error} = usePeople();
  const { loginID } = useAuthUser();
 
  const addImgDesc = useAddImgDesc();
  const uploadMedia = useUploadMedia();
  const updatePerson = useUpdatePerson();

  const inputRef = useRef(null);

  const MONTHS = [
    "", "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];

  const YEARS = [
    "", 
    ...Array.from(
      { length: new Date().getFullYear() - 1900 + 1 },
      (_, i) => new Date().getFullYear() - i
    ),
  ];

  const sortedPeopleOptions = Object.entries(people).sort(
    ([, personA], [, personB]) => {
      const nameA = (
        personA.AKA || `${personA.f_name} ${personA.l_name}`
      ).toLowerCase();
      const nameB = (
        personB.AKA || `${personB.f_name} ${personB.l_name}`
      ).toLowerCase();

      return nameA.localeCompare(nameB);
    }
  );


  useEffect (() => {
    if (selectedFiles.length > 0) {
      setIsData(true)
    } else {
      setIsData(false)
    }
  }, [selectedFiles])

  useEffect(() => {
    if (!people) return;

    setPeopleNames(
      Object.entries(people).map(([id, person]) => ({
        id,
        name: person.AKA || `${person.f_name} ${person.l_name}`,
        profile_pic: person.profile_pic
      }))
    );
  }, [people]);

  const keyVisuals = {
    "people": "People:",
    "date": {
      "month": "Month",
      "day": "Day",
      "year": "Year"
    },
    "reunion": "Was this at the Reunion",
    "subtext": "Image Description",
    "profilePic": "Is This a Profile Picture"
  }
  
  function handleButtonClick() {
    fileInputRef.current?.click();
  }

  function handleFileChange(event) {
    const files = Array.from(event.target.files);
    setSelectedFiles(prev => {
      const newFiles = [...prev, ...files];
      setSelectedDescs(prevDescs => {
        const newDescs = [...prevDescs];
        for (let i = prevDescs.length; i < newFiles.length; i++) {
          newDescs[i] = {
            people: [""],
            profilePic: "",
            reunion: "",
            date: {
              month: "",
              day: "",
              year: ""
            }
          };
        }
        return newDescs;
      });
      return newFiles;
    });
    event.target.value = null;
  }

  function removeFile(indexToRemove) {
    setSelectedFiles((prev) => 
      prev.filter((_, index) => index !== indexToRemove)
    );
    setSelectedDescs((prev) => 
      prev.filter((_, index) => index !== indexToRemove)
    );
    }

  function clearList() {
    setSelectedFiles([])
    setSelectedDescs([])
  }

  function handleInputting() {
    setInputtingID(selectedFiles[0])
    setCurrIdx(0)
    setInputDetails(true)
  }

  function cancelUpload() {
    setInputtingID(null)
    setCurrIdx(null)
    setInputDetails(false)
    // setSelectedFiles([])
  }

  const nextImage = () => {
    setInputtingID((currentFile) => {
      const index = selectedFiles.indexOf(currentFile);
      return selectedFiles[(index + 1) % selectedFiles.length];
    });
    setCurrIdx((currIdx + 1) % selectedFiles.length);
  };

  const prevImage = () => {
    setInputtingID((currentFile) => {
      const index = selectedFiles.indexOf(currentFile);
      return selectedFiles[
        (index - 1 + selectedFiles.length) % selectedFiles.length
      ];
    });
    setCurrIdx((currIdx - 1 + selectedFiles.length) % selectedFiles.length);
  };

  async function handleUploadAll() {
    setIsUploading(true);
    try {
      for (let index = 0; index < selectedFiles.length; index++) {
        setNumDone(index);
        const file = selectedFiles[index];

        const response = await uploadMedia.mutateAsync(file);

        const cleanedDesc = cleanDescs(selectedDescs[index]);
        const today = getLocalDateStringISO();

        await addImgDesc.mutateAsync({
          id: response.media_id,
          data: {
            img_name: file.name,
            saved_date: today,
            uploaded_by: loginID,
            ...cleanedDesc,
          }
        });

        if (!validIDPhoto(index, "disabled") && cleanedDesc.profilePic) {
          const selectedID = cleanedDesc.people[0];
          await updatePerson.mutateAsync({
            id: selectedID,
            data: {
              ...people[selectedID],
              profile_pic: response.media_id
            }
          });
        }
      }
      setSelectedFiles([]);
      setSelectedDescs([]);
      setSubmitted(true);
    } catch (err) {
      console.error("Upload failed", err);
    } finally {
      setIsUploading(false);
    }
  }

  function cleanDescs(data) {
    const cleaned = {};

    for (const [key, value] of Object.entries(data)) {
      if (value === "" || value === null || value === undefined || value === false) continue;
      if (Array.isArray(value)) {
        if (value.length === 0) continue;

        const cleanedArray = value
          .map(item => (typeof item === 'object' ? cleanDescs(item) : item))
          .filter(item =>
            typeof item === 'object'
              ? Object.keys(item).length > 0
              : item !== ""
          );
        if (cleanedArray.length === 0) continue;
        cleaned[key] = cleanedArray;
        continue
      }
      if (typeof value === "object") {
        // if (Object.values(value).includes(0)) continue;
        const cleanedObj = cleanDescs(value);
        if (Object.keys(cleanedObj).length === 0) continue;
        cleaned[key] = cleanedObj;
        continue;
      } 
      if (key === "reunion") {
        if (value) {
          cleaned[key] = `R${data["date"]["year"]}`;
        }
        continue;
      }
      if (key === "profilePic") {
        if (value) {
          cleaned[key] = `${data["people"][0]}_profile_pic`;
        }
        continue;
      }
      cleaned[key] = value;
    } 
    return cleaned;
  }

  function resetPage() {
    setSubmitted(false)
    setInputDetails(false)
    setInputtingID(null)
  }
  
  function updateField(index, key, value) { 
    setSelectedDescs(prev => {
      const newDescs = [...prev];

      if (!newDescs[index]) newDescs[index] = {};

      newDescs[index] = {
        ...newDescs[index],
        [key]: value
      };

      return newDescs;
    });
  }

  const getArray = (imgIndex, key) => {
    const arr = selectedDescs[imgIndex]?.[key];
    return Array.isArray(arr) ? arr : [""];
  };

  const updateArrayItem = (imgIndex, key, index, value) => {
    setSelectedDescs(prev => {
      const newDescs = [...prev];

      if (!newDescs[imgIndex]) newDescs[imgIndex] = {};

      const arr = newDescs[imgIndex][key] || [];
      const newArr = [...arr];

      newArr[index] = value;

      newDescs[imgIndex] = {
        ...newDescs[imgIndex],
        [key]: newArr
      };

      return newDescs;
    });
  };

  const addArrayItem = (imgIndex, key) => {
    setSelectedDescs(prev => {
      const newDescs = [...prev];

      if (!newDescs[imgIndex]) newDescs[imgIndex] = {};

      const arr = newDescs[imgIndex][key] || [];

      newDescs[imgIndex] = {
        ...newDescs[imgIndex],
        [key]: [...arr, ""]
      };

      return newDescs;
    });
  };

  // const removeArrayItem = (imgIndex, key, index) => {
  //   setSelectedDescs(prev => {
  //     const newDescs = [...prev];

  //     const arr = newDescs[imgIndex]?.[key] || [];

  //     if (index > 0) {
  //       const newArr = arr.filter((_, i) => i !== index);

  //       newDescs[imgIndex] = {
  //         ...newDescs[imgIndex],
  //         [key]: newArr
  //       };
  //     } 

  //     return newDescs;
  //   });
  // };
  const removeArrayItem = (imgIndex, key, index) => {
    setSelectedDescs(prev => {
      const newDescs = [...prev];
      const arr = newDescs[imgIndex]?.[key] || [];
      const newArr = arr.filter((_, i) => i !== index);

      if (newArr.length === 0) {
        newDescs.splice(imgIndex, 1);
      } else {
        newDescs[imgIndex] = {
          ...newDescs[imgIndex],
          [key]: newArr
        };
      }

      return newDescs;
    });
  };

  const getObject = (imgIndex, key, subKeys) => {
    const obj = selectedDescs[imgIndex]?.[key];
    const normalized = {};
    subKeys.forEach(subKey => {
      normalized[subKey] = obj?.[subKey] ?? "";
    });
    return normalized;
  };

  const updateObjectItem = (imgIndex, key, subKey, value) => {
    setSelectedDescs(prev => {
      const newDescs = [...prev];

      if (!newDescs[imgIndex]) newDescs[imgIndex] = {};

      const obj = newDescs[imgIndex][key] || {};

      newDescs[imgIndex] = {
        ...newDescs[imgIndex],
        [key]: {
          ...obj,
          [subKey]: value
        }
      };

      if (subKey === "year") {
        if (value % 4 === 0) {
          setIsLeapYear(true);
        }
      }

      if (subKey === "month") {
        if ([1,3,5,7,8,10,12].includes(value)) {
          setDayArray([
            "", 
            ...Array.from({length: 31}, (_, i) => i+1),
          ]);
        } else if ([4,6,9,11].includes(value)) {
          setDayArray([
            "", 
            ...Array.from({length: 30}, (_, i) => i+1),
          ]);
        } else if (value === 2 && isLeapYear) {
          setDayArray([
            "", 
            ...Array.from({length: 29}, (_, i) => i+1),
          ]);
        } else if (value === 2) {
          setDayArray([
            "", 
            ...Array.from({length: 28}, (_, i) => i+1),
          ]);
        } else {
          setDayArray([]);
          updateObjectItem(imgIndex, "date", "day", "")
        }
      }

      return newDescs;
    });
  };

  const validIDPhoto = (imgIndex, type) => {
    const people = selectedDescs[imgIndex]?.people || [];
    const notOnePerson = people.length !== 1 || people[0] === "";
    let hasIDPhoto = false;

    if (!notOnePerson) {
      const val_match = peopleNames.find(p => p.id === people[0]);
      hasIDPhoto = val_match?.profile_pic ? true : false;
    }

    const isDisabled = notOnePerson || hasIDPhoto;

    if (type === "disabled") {
      return isDisabled;
    } 
    if (!isDisabled) {
      return "";
    }
    if (people.length > 1) {
      return "More than one person in photo";
    }
    if (notOnePerson) {
      return "No people listed";
    }
    if (hasIDPhoto) {
      return "Person already has ID photo";
    }
  }

  const validReunion = (imgIndex, type) => {
    const year = selectedDescs[imgIndex]?.date?.year || false;

    const isDisabled = !year;

    if (type === "disabled") {
      return isDisabled;
    } 
    if (!isDisabled) {
      return "";
    }
    if (isDisabled) {
      return "Input the year";
    }
  }

  const renderField = (imgIndex, key, inputRef) => {
    if (key === "people") {
      const arr = getArray(imgIndex, key);
      return(
        // <div className="edit-input array-input">
        //   <label>{keyVisuals[key]}</label>
        //   {arr.map((val,i) => (
        //     <SearchBar
        //       peopleNames={peopleNames}
        //       inputRef={inputRef}
        //       imgIndex={imgIndex}
        //       arrKey={key} 
        //       i={i}
        //       updateArrayItem = {updateArrayItem}
        //       val={val}
        //     />
        //   ))}
        //   <div>
        //     <button
        //       type="button"
        //       className="sub-button add-array-item"
        //       onClick={() => addArrayItem(imgIndex, key)}
        //     >
        //       Another
        //     </button>
        //     <button
        //       type="button"
        //       className="sub-button remove-array-item"
        //       onClick={() => removeArrayItem(imgIndex, key, arr.length-1)}
        //     >
        //       Delete last
        //     </button>
        //   </div>
        // </div>

        <div className="filter-row edit-input array-input people-input">
          {/* <select 
            id="people-filter"
            value=""
            onChange={(e) => {
              updateArrayItem(imgIndex, key, arr.length, e.target.value)
              e.target.value = "";
            }}
          >
            <option value="">
              Select a person...
            </option>
            {sortedPeopleOptions
              .filter(([id]) => !arr.includes(id) && !id.startsWith("P0"))
              .map(([id, person]) => (
                <option key={id} value={id}>
                  {person.AKA || `${person.f_name} ${person.l_name}`}
                </option>
              ))
            }
          </select> */}
          <div className="people-row-1">
            <label htmlFor="people-filter" className="people-label">
              People:
            </label>
            <input
              id="people-filter"
              className="people-filter"
              list="people-options"
              placeholder="Select or type a name..."
              onChange={(e) => {
                const value = e.target.value;
                const person = sortedPeopleOptions.find(([id, person]) =>
                  (person.AKA || `${person.f_name} ${person.l_name}`) === value
                );

                if (person) {
                  updateArrayItem(imgIndex, key, arr.length, person[0]);
                  e.target.value = "";
                }
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter" && e.target.value.trim()) {
                  const value = e.target.value.trim();
                  const person = sortedPeopleOptions.find(([id, person]) =>
                    (person.AKA || `${person.f_name} ${person.l_name}`) === value
                  );

                  if (!person) {
                    updateArrayItem(imgIndex, key, arr.length, value);
                    e.target.value = "";
                  }
                }
              }}
            />

            <datalist id="people-options">
              {sortedPeopleOptions
                .filter(([id]) => !arr.includes(id) && !id.startsWith("P0"))
                .map(([id, person]) => (
                  <option 
                    key={id}
                    value={person.AKA || `${person.f_name} ${person.l_name}`}
                  />
                ))}
            </datalist>
          </div>

          {arr.length > 0 && (
            <div className="selected-people">
              {arr.map((id,i) => {
                const person = people[id];
                const name = person ? person.AKA || `${person.f_name} ${person.l_name}` : id;
                if (!name) return null;
                return (
                  <div key={i} className="selected-person">
                    <button 
                      className="selected-person-button" 
                      onClick={() => removeArrayItem(imgIndex, key, i)}
                    >
                      {name}
                    </button>
                  </div>
                )
              })}
            </div>
          )}
        </div>
      );
    } else if (key === "date") {
      let subKeys = [];
      let keyName = "";
      if (key === "date") {
        subKeys = ["month", "day", "year"];
        keyName = "Date Taken";
      }
      const obj = getObject(imgIndex, key, subKeys);
      return(
        <div className={`edit-input object-input date-input`} key={key}>
          <label>{keyName}:</label>
          {subKeys.map((subKey) => (
            <div className="edit-input object-element" key={subKey}>
              <div className="sub-label">{keyVisuals[key][subKey]}</div>
              {subKey === "month" && 
                <select
                  className={`sub-input date-subinput ${subKey}-box`}
                  value={obj[subKey]}
                  onChange={(e) => {updateObjectItem(imgIndex, key, subKey, e.target.value ===""?"":Number(e.target.value))}}
                >
                  {MONTHS.map((month, index) => (
                    <option key={month} value={index}>
                      {month}
                    </option>
                  ))}
                </select>   
              }
              {subKey === "day" && 
                <select
                  className={`sub-input date-subinput ${subKey}-box ${dayArray.length ? "" : "day-disabled"}`}
                  value={obj[subKey]}
                  disabled={dayArray.length === 0}
                  onChange={(e) => {updateObjectItem(imgIndex, key, subKey, e.target.value ===""?"":Number(e.target.value))}}
                >
                  {dayArray.map(day => (
                    <option key={day} value={day}>
                      {day}
                    </option>
                  ))}
                </select>   
              } 
              {subKey === "year" && 
                <select
                  className={`sub-input date-subinput ${subKey}-box`}
                  value={obj[subKey]}
                  onChange={(e) => {updateObjectItem(imgIndex, key, subKey, e.target.value ===""?"":Number(e.target.value))}}
                >
                  {YEARS.map(year => (
                    <option key={year} value={year}>
                      {year}
                    </option>
                  ))}
                </select>   
              } 
            </div>
          ))}    
        </div>
      )
    } else if (key === "reunion") {
      return(
        <div className="profile-pic" title={validReunion(imgIndex, "hover")}>
          <label className={`single-label${validReunion(imgIndex, "disabled") ? "-disabled" : ""} edit-img-reunion`}>{keyVisuals[key]}?</label>
          <input
            type='checkbox'
            className='pic-check'
            checked={selectedDescs[imgIndex]?.[key] ?? false}
            onChange={(e) => updateField(imgIndex, key, e.target.checked)}
            disabled={validReunion(imgIndex, "disabled")}
          />
        </div>
      )
    } else if (key === "subtext") {
      return(
        <div className="subtext-input">
          <label className={`single-label`}>{keyVisuals[key]}:</label>
          <textarea
            value={selectedDescs[imgIndex]?.[key] ?? ""}
            rows={1}
            onInput={(e) => {
              e.target.style.height = "auto";
              e.target.style.height = e.target.scrollHeight + "px";
            }}
            onChange={(e) => updateField(imgIndex, key, e.target.value)}
            autoComplete='batman'
            className={`${key}-box${(selectedDescs[imgIndex]?.[key]?.length === 64) ? ' max-len' : ''}`}
            placeholder="What's in this photo?"
            maxLength={64}
            title={(selectedDescs[imgIndex]?.[key]?.length === 64) ? 'Maximum Length' : ''}
          />
          {selectedDescs[imgIndex]?.[key]?.length === 64 &&
            <label className={`single-label maximum`}>Maximum Length</label>
          }
        </div>
      )
    } else if (key === "profilePic") {
      return(
        <div className="profile-pic" title={validIDPhoto(imgIndex, "hover")}>
          <label className={`single-label${validIDPhoto(imgIndex, "disabled") ? "-disabled" : ""}`}>{keyVisuals[key]}?</label>
          <input
            type='checkbox'
            className='pic-check'
            checked={selectedDescs[imgIndex]?.[key] ?? false}
            onChange={(e) => updateField(imgIndex, key, e.target.checked)}
            disabled={validIDPhoto(imgIndex, "disabled")}
          />
        </div>
      )
    }
  }

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (!isData) return;
      
      event.preventDefault();
      event.returnValue =
        "Are you sure you want to leave this page? Any data will not be saved.";
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    }
  }, [isData]);

  usePrompt(
    "Are you sure you want to leave this page? Any data will not be saved.",
    isData
  );

  return (
    <div className="edit-img-page">
      {!submitted && !inputDetails &&
        <div className="img-selection">
          <div className="page-title">Add New Images</div>
          <div className={`img-select${!selectedFiles.length ? " empty" : ""}`}>
            <input 
              ref={fileInputRef}
              type="file"
              accept="image/*,video/*"
              multiple
              style={{display:"none"}}
              onChange={handleFileChange}
            />
            <button className="choose-photos" onClick={handleButtonClick}>
              Choose Photos   
            </button>
            <button className="choose-photos clear" disabled={!selectedFiles.length} onClick={clearList}>Clear List</button>
          </div>
          {selectedFiles.length > 0 && (
            <div className="pictures-list">
              <ul>
                {selectedFiles.map((file, index) => {
                  const previewUrl = URL.createObjectURL(file);
                  return (
                    <li key={`${file.name}-${index}`} className="picture-item">
                      <button
                        type="button"
                        className="remove-button"
                        onClick={() => removeFile(index)}
                      >
                        {file.type.startsWith("image/") && (
                        <img
                          src={previewUrl}
                          alt={file.name}
                          className="thumbnail"
                          onLoad={() => URL.revokeObjectURL(previewUrl)}
                        />
                        )}
                        {file.type.startsWith("video/") && (
                          <video
                            src={previewUrl}
                            className="thumbnail"
                            muted
                            preload="metadata"
                            onLoadedData={() => {URL.revokeObjectURL(previewUrl)}}
                          />
                        )}
                        {!(file.type.startsWith("image/")) && !file.type.startsWith("video/") && '\u00D7'}
                        <span>{file.name}</span>
                      </button>
                    </li>
                  );
                })}
              </ul>
              <div className="tooltip">Click on a photo to remove it</div>
              <button className="add-descs" onClick={handleInputting}>
                Add Details
              </button>
            </div>
          )}
          <div className="other-links">
            <Link to={'/uploaded-photos'} className="img-page-link">Your Previously Uploaded Photos</Link>
          </div>
        </div>
      }
      {inputDetails && !submitted && inputtingID &&
        <div className="inputting-data" ref={inputRef}>
          <div className="inputting-title">Add Details To Your Images</div>
          <div className="inputting-subtitle">Leave Any Unknown Fields Blank</div>
          <div className="image-data">
            {inputtingID.type.startsWith("image/") && (
              <img
              src={URL.createObjectURL(inputtingID)}
              alt={inputtingID.name}
              onLoad={(e) => URL.revokeObjectURL(e.target.src)}
            />
            )}
            {inputtingID.type.startsWith("video/") && (
              <video
                src={URL.createObjectURL(inputtingID)}
                muted
                preload="metadata"
                onLoadedData={(e) => {URL.revokeObjectURL(e.target.src)}}
              />
            )}
            <div className="input-section">
              {renderField(currIdx, "people", inputRef)}
              {renderField(currIdx, "date")}
              {renderField(currIdx, "reunion")}
              {renderField(currIdx, "subtext")}
              {/* {renderField(currIdx, "profilePic")} */}
            </div>
            {selectedFiles.length > 1 &&
              <div>
                <button className='scroll-button back-button' onClick={prevImage}>
                  {'\u2039'}
                </button>
                <button className='scroll-button next-button' onClick={nextImage}>
                  {'\u203A'}
                </button>
                <div className="index-number">Photo # {currIdx + 1} / {selectedFiles.length}</div>
                <div className="index-name">{selectedFiles[currIdx].name}</div>
              </div>
            }
          </div>
          <button className="input-button cancel" onClick={cancelUpload} title="Details will be saved">
            Cancel Upload
          </button>
          <button className="input-button upload" disabled={currIdx !== selectedFiles.length - 1} onClick={handleUploadAll} title="Scroll to last image to upload">
            Upload All Images
          </button>
        </div>
      }
      {isUploading &&
        <div className="uploading loading-overlay">
          <div className="uploading-text">Uploading Images ({numDone}/{selectedFiles.length})</div>
          <div className='progress-bar'>
            <div className='progress-fill' style={{width: `${numDone/selectedFiles.length * 100}%`}} />
          </div>
        </div>
      }
      {submitted &&
        <div className="submitted">
          <div className="struct-div">
            <div className="sub-message">Submitted Successfully!</div>
            <button onClick={resetPage}>
              Submit More
            </button>
          </div>
        </div>
      }
    </div>
  )
}


function SearchBar ({peopleNames, inputRef, imgIndex, arrKey, i, updateArrayItem, val}) {
  const val_match = peopleNames.find(p => p.id === val);
  const [query, setQuery] = useState(val_match ? val_match.name : val?? "");
  const [suggestions, setSuggestions] = useState([]);
  const wrapperRef = useRef(null); 
  const popupRef = useRef(null);
  
  useEffect(() => {
    const inputBox = inputRef.current;
    if (!inputBox) return;

    function handleClick(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setSuggestions([]);
      }
    }

    document.addEventListener("mousedown", handleClick);

    return () => {
      document.removeEventListener("mousedown", handleClick);
    };
  }, [inputRef]);


  useEffect(() => {
    const popupEl = popupRef.current;
    if (!popupEl) return;

    function lockScroll(e) {
      const { scrollTop, scrollHeight, clientHeight } = popupEl;
      const atTop = scrollTop === 0;
      const atBottom = scrollTop + clientHeight >= scrollHeight;

      const scrollingUp = e.deltaY < 0;
      const scrollingDown = e.deltaY > 0;
 
      if ((scrollingUp && atTop) || (scrollingDown && atBottom)) {
        e.preventDefault();
        e.stopPropagation();
        return;
      }
      e.stopPropagation();
    }

    popupEl.addEventListener("wheel", lockScroll, { passive: false });

    return () => {
      popupEl.removeEventListener("wheel", lockScroll);
    };
  }, [suggestions]);
  
  useEffect(() => {
    const match = peopleNames.find(p => p.id === val);
    setQuery(match?.name ?? val ?? "");
  }, [val, peopleNames]);

  function handleChange(e) {
    const value = e.target.value;
    setQuery(value);

    updateArrayItem(imgIndex, arrKey, i, value);

    if (!value.trim()) {
      setSuggestions([]);
      return;
    }

    setSuggestions(
      peopleNames.filter(p =>
        p.name.toLowerCase().includes(value.toLowerCase())
      )
    );
  }

  function handleSuggestionClick(person) {
    setQuery(person.name);
    setSuggestions([]);

    updateArrayItem(imgIndex, arrKey, i, person.id)
  }

  useEffect(() => {
    if (!peopleNames) return;

    const match = peopleNames.find(
      p => p.name.toLowerCase() === query.toLowerCase()
    );

    updateArrayItem(
      imgIndex,
      arrKey,
      i,
      match ? match.id : query
    );
  }, [query, peopleNames]);

  return (
    <span className='person-wrapper' ref={wrapperRef}>
      {suggestions.length > 0 && (
        <div className='suggestions-popup' ref={popupRef}>
          {suggestions.map((p) => (
            <div
              key={p.id}
              className='suggestions-item'
              onClick={() => handleSuggestionClick(p)}
            >
              {p.name}
            </div>
          ))}
        </div>  
      )}
      <input
        key={`${imgIndex}-${arrKey}-${i}`}
        type="text"
        value={query}
        onChange={handleChange}
        autoComplete='batman'
      />
    </span>
  )
}